/**
 * 身份认证接口
 * 对应 server/src/modules/auth/auth.controller.ts
 */
import { http } from "@/lib/api/http";
import type { AuthContext, LoginResult, Role } from "@/lib/api/types";

export type LoginInput = {
  /** 商户编码，如 TONI-DEMO。一个门店对应一个商户 */
  merchantCode: string;
  mobile: string;
  password: string;
};

export const authApi = {
  /** 登录。这是唯一一个不需要带 token 的接口 */
  login: (input: LoginInput) =>
    http.post<LoginResult>("/auth/login", { body: input, skipAuth: true }),

  /**
   * 拉取当前登录上下文（门店、角色、权限码）。
   * 每次启动应用都要调一次：权限以服务端为准，不能信本地缓存。
   */
  me: () => http.get<AuthContext>("/me"),

  /** 角色与权限清单。给员工分配角色在「员工与工资 → 花名册」，角色本身在门店设置里维护 */
  roles: () => http.get<Role[]>("/roles"),

  /** 校验当前密码后更新 Argon2 哈希；不会把密码写进本地缓存。 */
  changePassword: (input: { currentPassword: string; newPassword: string }) =>
    http.post<{ changed: true }>("/auth/change-password", { body: input }),
};
